import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useContext } from 'react';

import { AppBar } from '@uptime/design-system/components/AppBar';
import { Box } from '@uptime/design-system/components/Box';
import { Button } from '@uptime/design-system/components/Button';
import { IconButton } from '@uptime/design-system/components/IconButton';
import { Toolbar } from '@uptime/design-system/components/Toolbar';
import { Typography } from '@uptime/design-system/components/Typography';
import MenuIcon from '@uptime/design-system/icons/MenuIcon';
import { ThemeProviderV7 } from '@uptime/design-system/MUIv7Exports';
import { UIContext } from '@uptime/shared/providers/UIProvider';

import useAuth from '@/common/hooks/useAuth';

import useStyles from '../styles';

const Header = () => {
  const classes = useStyles();
  const { sidebarIsOpen, setSidebarIsOpen } = useContext(UIContext);
  const { onSignOut, userName, isLoggedIn } = useAuth();

  const handleDrawerToggle = () => {
    setSidebarIsOpen(!sidebarIsOpen);
  };

  return (
    <ThemeProviderV7>
      <AppBar position="fixed" className={classes.appBar} color="default">
        <Toolbar className={classes.toolbar}>
          <Box display="flex" alignItems="center">
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              className={classes.menuButton}
              size="large"
            >
              <MenuIcon />
            </IconButton>
            <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
              Partner Portal
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {userName && <Typography className={classes.userName}>{userName}</Typography>}
            {isLoggedIn && (
              <Button
                onClick={onSignOut}
                startIcon={<ExitToAppIcon />}
                className={classes.logoutBtn}
                data-testid="logout"
              >
                Logout
              </Button>
            )}
          </Box>
        </Toolbar>
      </AppBar>
    </ThemeProviderV7>
  );
};

export default Header;
